// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uiF0ti","menuItem":"_3-GouR_","label":"_2KVLkPB","label__sale":"_1mGvVLn","image":"_2ipto0o"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css
// module chunks = client.sitechrome